import store from '@/store/index'

export default function (flag) {
  return store.getters.getFlags.some(x => x === flag)
}
